<template>
  <div class="late-blight__warn" v-loading="loading">
    <div class="title" style="position:absolute;left: 20px;top: 18px;">
      <el-tag size="large">马铃薯晚疫病</el-tag>
    </div>

    <echart
      chartId="late-blight_warn"
      :options="options"
      :height="120"
    ></echart>
  </div>
</template>

<script>
import Echart from '@/components/Chart'

export default {
  components: { Echart },
  props: {
    loading: Boolean
  },
  data() {
    return {
      value: 1
    }
  },
  computed: {
    options() {
      const { value } = this
      return {
        title: {
          text: '未侵染',
          left: '50%',
          top: '80%',
          padding: 0,
          textAlign: 'center',
          textStyle: {
            fontWeight: 400,
            fontSize: 14,
            color: '#13ce66'
          }
        },
        grid: {
          show: false,
          containLabel: false,
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        },
        tooltip: { show: false },
        xAxis: { show: false },
        yAxis: { show: false },
        legend: { show: false },
        toolbox: { show: false },
        series: [
          {
            type: 'pie',
            center: ['50%', '90%'],
            radius: ['100%', '160%'],
            startAngle: 180,
            endAngle: 0,
            itemStyle: {
              borderColor: 'rgb(215, 215, 215)'
            },
            color: ['#13ce66', '#D8D8D8', 'transparent'],
            silent: true,
            labelLine: { show: false },
            data: [
              value,
              100 - value,
              {
                value: 100,
                itemStyle: {
                  borderWidth: 0
                }
              }
            ]
          }
        ]
      }
    }
  },
  methods: {},
  watch: {
    loading(v) {
      if (!v) {
        this.value = Math.floor(Math.random() * 5) + 1
      }
    }
  }
}
</script>

<style lang="css" scoped>
.late-blight__warn {
  position: relative;
  background: #f2f6fc;
  border-bottom: 1px solid #dcdfe6;
  height: 120px;
}
</style>
